const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

function prefersReducedMotion() {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return false;
    }
    return window.matchMedia(REDUCED_MOTION_QUERY).matches;
}

function resolveScrollBehavior() {
    return prefersReducedMotion() ? 'auto' : 'smooth';
}

export { REDUCED_MOTION_QUERY, prefersReducedMotion, resolveScrollBehavior };
